"use strict";

import warnAboutDeprecatedESMImport from "./warnAboutDeprecatedESMImport.js";
warnAboutDeprecatedESMImport("Router");
import { Router } from "../esm/react-router.js";
export default Router;